export default {
	ids: [],
	glsl: `
vec3 bandColor(float idx, float turns, float blur);

// The ground premultiplied: the surface between and behind the lines; fog fades lines to it.
vec4 groundColor() {
	return vec4(uGround.rgb * uGround.a, uGround.a);
}

// Premultiplied colour. Band coverage: each band its palette entry, a crossing weighed by cover. All over the ground.
vec4 profile(Cell c, float h) {
	vec3 col = bandColor(c.idx.x, c.turns, c.blur);
	if (uCross > 0.0) {
		vec3 lineY = bandColor(c.idx.y, 0.0, c.blur);
		float cover = c.cov.x + c.cov.y;
		vec3 line = cover > 1e-4 ? (col * c.cov.x + lineY * c.cov.y) / cover : col;
		col = mix(line, col * (1.0 - 0.5 * uCross) + lineY * (0.5 * uCross), c.blur);
	}
	vec4 bands = vec4(col, 1.0) * c.band;
	if (uGround.a > 0.0) bands += groundColor() * (1.0 - bands.a);
	return bands;
}
`,
}
